<script lang="ts">
	import { formatMonthString, getStartOfMonth } from '$lib/utils/Date';
	import { classes } from '@thearc-hq/ui-kit/utils';
	import { createEventDispatcher } from 'svelte';
	import ChevronHorizontalButton from '../Button/ChevronHorizontalButton.svelte';

	export let selectedMonth: Date;
	// The minimum length in px - to avoid jumping from smaller to longer month strings.
	export let minLength: number;
	export let minDate: Date;
	export let maxDate: Date;

	const dispatch = createEventDispatcher();

	function handleClick(previousClick: boolean) {
		if (previousClick) {
			dispatch('previousMonthClick');
		} else {
			dispatch('nextMonthClick');
		}
	}
</script>

<div class="flex items-center justify-between space-x-8 lg:min-w-content lg:justify-center">
	<ChevronHorizontalButton
		on:click={() => handleClick(true)}
		chevronLeft={true}
		disabled={getStartOfMonth(selectedMonth) <= getStartOfMonth(minDate)}
	/>
	<span
		class="font-semibold text-center min-w-max text-h-16 whitespace-nowrap"
		style="min-width: {minLength}px"
	>
		{formatMonthString(selectedMonth)}
	</span>
	<ChevronHorizontalButton
		on:click={() => handleClick(false)}
		disabled={getStartOfMonth(selectedMonth) >= getStartOfMonth(maxDate)}
	/>
</div>
